import React, {useState} from "react";
import {Col, FormGroup, Input, Row} from "reactstrap";
import {every, isEmpty} from "lodash";
import {toast} from "react-toastify";

// import PropTypes from "prop-types";

const INITIAL_LOCAL_STATE = {
  address: {
    mailing: {},
    billing: {},
    shipping: {},
  },
};

const ADDRESS_GROUPS = {
  mailing: "Mailing Address",
  billing: "Billing Address",
  shipping: "Shipping Address",
};

const MANDATORY_KEYS = ["street_address1", "city", "state", "country", "zip_code"];
function AddressInformation(_props, ref) {
  const [addressObject, setAddressObject] = useState(INITIAL_LOCAL_STATE);
  const [submitted, setSubmitted] = useState(false);

  const checkForValidObject = (type) => {
    const {address = {}} = addressObject;
    if (!isEmpty(address[type])) {
      return every(MANDATORY_KEYS, (each) => !!address[`${type}`][each]);
    }
    return false;
  };
  const checkForValidation = () => {
    setSubmitted(true);
    const validated_mailing_address = checkForValidObject("mailing");
    const validated_shipping_address = checkForValidObject("shipping");
    const validated_billing_address = checkForValidObject("billing");
    if (
      validated_mailing_address &&
      validated_shipping_address &&
      validated_billing_address
    ) {
      return true;
    } else {
      toast.error("Please check required fields");
      return false;
    }
  };

  /* ## This Imperative Handle and customizes the instance value that is exposed to parent components when using ref. Please Don't Remove this Line ## */
  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return checkForValidation();
    },
    state: addressObject,
  }));

  const onChangeHandler = (e, dataFor) => {
    const {name, value} = e.target;
    const {address} = addressObject;
    setAddressObject({
      address: Object.assign({}, address, {
        [dataFor]: Object.assign({}, address[dataFor], {[name]: value}),
      }),
    });
  };
  const {address} = addressObject;
  return (
    <div className="pl-lg-4">
      {Object.keys(ADDRESS_GROUPS).map((addressType) => {
        const {
          street_address1 = "",
          city = "",
          state = "",
          country = "",
          zip_code = "",
        } = address[addressType];
        return (
          <>
            <Row>
              <Col md="12">
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">
                    {ADDRESS_GROUPS[addressType]}
                    <span className="text-red">*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    placeholder="Address"
                    type="textarea"
                    name={"street_address1"}
                    invalid={isEmpty(street_address1) && submitted}
                    data-cy={`${addressType}_street_address1`}
                    value={street_address1}
                    onChange={(event) => onChangeHandler(event, addressType)}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">
                    City<span className="text-red">*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    placeholder="Name"
                    type="text"
                    invalid={isEmpty(city) && submitted}
                    name={"city"}
                    data-cy={`${addressType}_city`}
                    value={city}
                    onChange={(event) => onChangeHandler(event, addressType)}
                  />
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">
                    State<span className="text-red">*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    placeholder="State"
                    type="text"
                    name={"state"}
                    invalid={isEmpty(state) && submitted}
                    data-cy={`${addressType}_state`}
                    value={state}
                    onChange={(event) => onChangeHandler(event, addressType)}
                  />
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">
                    Country<span className="text-red">*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    placeholder="Country"
                    type="text"
                    name={"country"}
                    data-cy={`${addressType}_country`}
                    value={country}
                    invalid={isEmpty(country) && submitted}
                    onChange={(event) => onChangeHandler(event, addressType)}
                  />
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-name">
                    Zip Code<span className="text-red">*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    // defaultValue="Bld Mihail Kogalniceanu, nr. 8 Bl 1, Sc 1, Ap 09"
                    placeholder="Zip Code"
                    type="number"
                    name={"zip_code"}
                    data-cy={`${addressType}_zip_code`}
                    value={zip_code}
                    invalid={isEmpty(zip_code) && submitted}
                    onChange={(event) => onChangeHandler(event, addressType)}
                  />
                </FormGroup>
              </Col>
            </Row>
            <hr />
          </>
        );
      })}
    </div>
  );
}

AddressInformation.propTypes = {};

export default React.forwardRef(AddressInformation);
